export const contentEmailLoading =  ({store})  => store.contentEmailReducer.loading;

export const contentEmailError =  ({store})  => store.contentEmailReducer.error;

export const contentEmailData =  ({store})  => store.contentEmailReducer.data;